import React from 'react';
import { classNames } from '../../../../utils/common/styling.js';
import { getThemedStyles, styles } from './SectionCTA.styles.js';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/CreateOutlined';
import { useCreatorThemeContext } from '../../../../features/Common/modules/Theme/CreatorThemeContext.js';

var SectionCTA = function (_a) {
    var label = _a.label, active = _a.active, icon = _a.icon, onClick = _a.onClick, className = _a.className, labelClassName = _a.labelClassName, labelStyle = _a.labelStyle, showActions = _a.showActions, onEdit = _a.onEdit;
    var theme = useCreatorThemeContext();
    var themedStyles = getThemedStyles({ theme: theme });
    return (React.createElement("div", { className: classNames(styles.root, active && styles.active, active && themedStyles.active, className), onClick: onClick },
        React.createElement("div", { className: styles.labelContainer },
            icon,
            React.createElement("span", { className: classNames(styles.labelText, active ? themedStyles.activeText : styles.notActiveText, labelClassName), style: labelStyle }, label)),
        showActions && (React.createElement("div", { className: styles.actions },
            React.createElement(IconButton, { onClick: function (e) {
                    // to not trigger `onClick` of cta itself on click of edit button
                    e.stopPropagation();
                    onEdit === null || onEdit === void 0 ? void 0 : onEdit(e);
                } },
                React.createElement(EditIcon, null))))));
};

export { SectionCTA as default };
//# sourceMappingURL=SectionCTA.js.map
